export default __webpack_public_path__ + "static/icon-285c35f06ce7e796e95e9539d1335635.png";